import type { AuthResponse } from '../types';

export const saveUser = async (data: AuthResponse): Promise<void> => {
  const { token, email, displayName, userName, userId } = data;

  localStorage.setItem('token', token);
  localStorage.setItem('email', email);
  localStorage.setItem('displayName', displayName);
  localStorage.setItem('userName', userName);
  localStorage.setItem('userId', userId);
};

export const logoutUser = (): void => {
  localStorage.removeItem('token');
  localStorage.removeItem('email');
  localStorage.removeItem('displayName');
  localStorage.removeItem('userName');
  localStorage.removeItem('userId');
};

export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

export const setToken = (token: string): void => {
  localStorage.setItem('token', token);
};
